import React from 'react';
import { Title1, Text, Button, makeStyles, tokens } from '@fluentui/react-components';
import { useMsalAuth } from '../hooks/useMsalAuth';

const useStyles = makeStyles({
  root: {
    display: 'grid',
    placeItems: 'center',
    padding: tokens.spacingVerticalXXXL,
    minHeight: '60vh',
  },
  content: {
    maxWidth: '600px',
    textAlign: 'center',
    display: 'grid',
    gap: tokens.spacingVerticalM,
  },
});

export default function Welcome() {
  const styles = useStyles();
  const { login } = useMsalAuth();

  return (
    <div className={styles.root}>
      <div className={styles.content}>
        <Title1>Welcome to TRAPI Self Service</Title1>
        <Text>
          Please sign in to continue. If your session expired, signing in will refresh your access.
        </Text>
        <div>
          <Button appearance="primary" onClick={() => login()}>Sign in</Button>
        </div>
      </div>
    </div>
  );
}
